import Link from '@cartwhl/common/components/Link';
import Text from '@cartwhl/ui/base/Text';

export const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15MB in bytes

export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.gif'];

export const ModalConfig = {
  'file picker': {
    title: 'Upload image',
    maxWidth: 547,
  },
  'media capture': {
    title: (
      <div className="flex w-full flex-col justify-between sm:flex-row">
        <Text variant="studio/title/md" className="mb-1">
          Capture image
        </Text>
        <div className="text-gray-60 dark:text-gray-45">
          For more details see our{' '}
          <Link
            className="text-blue"
            href="https://docs.getcartwheel.com/docs/creating-motion/video-to-motion"
            target="_blank"
          >
            image capture documentation
          </Link>
          .
        </div>
      </div>
    ),
    maxWidth: 971,
  },
  cropping: {
    title: (
      <>
        <div className="flex w-full flex-row justify-between">
          <Text variant="studio/title/lg">Crop & rotate</Text>
          <div className="text-gray-60 dark:text-gray-45">
            Crop and rotate to focus on the subject.
          </div>
        </div>
      </>
    ),
    maxWidth: 971,
  },
  upload: {
    title: 'Upload image',
    maxWidth: 547,
  },
};
